import myAxios from 'axios';

let axios = myAxios.create({
	baseURL: '/',
	timeout: 10000,
	headers: {
		'Accept': 'application/json'
	}
});

const api = {
	getMailingLists: () => {
		return axios.get('/en/mailing-lists/index')
			.then((data) => {
				if (data.status === 200) {
					return data.data.mailingLists;
				}
			});
	},
	getNewsletterRecipient: () => {
		return axios.get('/en/mailing-lists/recipients/edit')
			.then((data) => {
				if (data.status === 200) {
					return data.data;
				}
			});
	}
};

export default api;
